import React from "react";
import { Link } from "react-router-dom";
import './NotFound.scss'

const NotFound = () => {
    return (
        <>
            <div id="notfound">
                <div class="notfound">
                    <div class="notfound-404">
                        <h1>404</h1>
                    </div>
                    <h2>صفحه مورد نظر یافت نشد</h2>

                    <Link to="/">
                        <span class="arrow" />
                        برگشت به صفحه اصلی
                    </Link>
                </div>
            </div>
        </>
    );
};

export default NotFound;
